// removed by extract-text-webpack-plugin
module.exports = {"classPagination":"Pagination-classPagination-b84dae33","classPaginationButton":"Pagination-classPaginationButton-665f2d90","classPaginationActive":"Pagination-classPaginationActive-6750d962","classPaginationSpacer":"Pagination-classPaginationSpacer-36172b60","classPaginationNavigation":"Pagination-classPaginationNavigation-0763e855","classPaginationNavigationPrevious":"Pagination-classPaginationNavigationPrevious-8be20a6f","classPaginationNavigationNext":"Pagination-classPaginationNavigationNext-297b5d23","classPaginationSmaller":"Pagination-classPaginationSmaller-db7d088f"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Pagination.scss
// module id = 826
// module chunks = 0